import { jsxs as o, jsx as c } from "react/jsx-runtime";
import e from "./styles.module.less.js";
const u = (d) => {
  const {
    label: l,
    path: t,
    isScrolledHeader: a,
    className: s,
    onClick: n,
    labelClassName: r,
    children: i,
    isOpen: $
  } = d;
  return t ? /* @__PURE__ */ o(
    "a",
    {
      href: t,
      onClick: n,
      className: `${e.gradientButton} ${a ? e.isScrolled : ""} ${s ?? ""}`,
      children: [
        /* @__PURE__ */ c("div", { className: `${e.gradientButtonLabel} ${r ?? ""}`, children: l }),
        i
      ]
    }
  ) : /* @__PURE__ */ o(
    "button",
    {
      className: `${e.gradientButton} ${a ? e.isScrolled : ""} ${$ ? e.isOpen : ""}
      } ${s ?? ""}`,
      onClick: n,
      children: [
        /* @__PURE__ */ c("div", { className: `${e.gradientButtonLabel} ${r ?? ""}`, children: l }),
        i
      ]
    }
  );
};
export {
  u as GradientButton
};
